import React from 'react';
import PrivacyPolicy from './PrivacyPolicy';
import './App.css';

function App() {
  return (
    <div className="App">
      <PrivacyPolicy />
    </div>
  );
}

export default App;
